import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close dropdown when clicking outside
    this.clickOutside = this.clickOutside.bind(this)
    
    // Close navbar when clicking dropdown items on mobile
    this.dropdownItems = this.element.querySelectorAll('.dropdown-item')
    this.dropdownItems.forEach(item => {
      item.addEventListener('click', () => this.closeNavbarOnMobile())
    })
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    // Close other dropdowns
    document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.classList.remove('show')
      }
    })
    
    // Toggle this dropdown
    this.menuTarget.classList.toggle('show')
    
    if (this.menuTarget.classList.contains('show')) {
      document.addEventListener('click', this.clickOutside)
    } else {
      document.removeEventListener('click', this.clickOutside)
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.remove('show')
      document.removeEventListener('click', this.clickOutside)
    }
  }
  
  closeNavbarOnMobile() {
    // Close navbar on mobile when clicking a dropdown item
    if (window.innerWidth < 992) {
      const navbar = document.querySelector('[data-controller*="navbar"]')
      if (navbar) {
        const navbarController = this.application.getControllerForElementAndIdentifier(navbar, 'navbar')
        if (navbarController) {
          navbarController.close()
        }
      }
    }
  }

  disconnect() {
    document.removeEventListener('click', this.clickOutside)
    this.dropdownItems.forEach(item => {
      item.removeEventListener('click', () => this.closeNavbarOnMobile())
    })
  }
}

